// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3YRHV","bigColWidth":"Table_bigColWidth__16FFZ","biggerColWidth":"Table_biggerColWidth__30flI","row":"Table_row__2nZxO","col":"Table_col__2qt3X"};